$(document).ready(function() {

    jQuery.validator.addMethod('engraveSelectCheck', function(val) {
        if ($('#IncludeEngravingYes').is(":checked")) {
            if (val != "none") {
                return true;
            } else {
                return false;
            }
        }
    });

    jQuery.validator.addMethod('filesize', function (value, element, param) {
        return this.optional(element) || (element.files[0].size <= param)
    }, 'File size must be less than 250 MB');
   
    jQuery.extend(jQuery.validator.messages, {
        required: '<i class="fa fa-exclamation-triangle"></i> This field is required.'
    });

    function handleCamServicesRequestSubmit(formName) {
        dispatchStullerEvent('track-event', {
            event: 'form_completed',
            details: {
                form_name: formName,
                generate_lead: true,
                value: 0,
                currency: 'USD'
            }
        });
    }

    $('#requestForm').validate({
        submitHandler: function (form) {
            form.submit();
        },
        highlight: function(element) {
            $(element).closest('.formWell').addClass('has-error');
            if ($(element).attr("name") == "Quantity" || $(element).attr("name") == "StullerItemNumber"){
                $(element).closest('.formWellQuantity').addClass('has-error');
            } else if ($(element).attr("name") == "Base") {
                $(element).parent().siblings('.metalsError').addClass('errorShow');
            } else if ($(element).attr("name") == "BaseGold") {
                $(element).parents('.metalSpecType').siblings('.metalsError').addClass('errorShow');
            } else if ($(element).attr("name") == "StullerItemNumber") {
                $(element).closest('.formWellQuantity').addClass('has-error');
            }
            else if ($(element).attr("name") == "BaseMetal") {
                $(element).siblings('.inputError').addClass('errorShow');
              
            }
            else if ($(element).attr("class") == "fullWidth xsWidthSelect castingMaterial_material") {
                $(element).addClass('waxError');
            }

            else if ($(element).attr("class") == "xsWidthSelect castingMaterial_metal") {
                $(element).addClass('waxError');
            }

            else if ($(element).attr('class') == "castingMaterials_OtherMaterial") {
                $(element).addClass('waxError');
            }

        },

        unhighlight: function(element) {
            if ($(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.FirstName" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.LastName" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.BusinessPhoneNumber" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.MobilePhoneNumber" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.EmailAddress") {
                $(element).removeClass('has-error');
                $(element).siblings('.inputError').removeClass('errorShow');
            }
           
            else if ($(element).attr("name") == "cadFile") {
                $(element).siblings('.individualError ').removeClass('errorShow');
            }

            else if ($(element).attr("name") == "Quantity" || $(element).attr("name") == "StullerItemNumber") {
                $(element).closest('.formWellQuantity').removeClass('has-error');
                $(element).siblings('.inputError').removeClass('errorShow');
            }

            else if ($(element).attr("name") == "StullerItemNumber") {
                $(element).siblings('.inputError').removeClass('errorShow');
                $(element).closest('.formWellQuantity').removeClass('has-error');
            }

            else if ($(element).attr("name") == "BaseMetal" || $(element).attr("name") == "BaseMetalVerbose") {
                $(element).siblings('.metalError').removeClass('errorShow');
            }

            else if ($(element).attr("class") == "trim" || $(element).attr("class") == "trimVerbose") {
                $(element).siblings('.metalError').removeClass('errorShow');
            }

            else if ($(element).attr("class") == "fullWidth xsWidthSelect castingMaterial_material waxError") {
                $(element).removeClass('waxError');
            }

            else if ($(element).attr("class") == "xsWidthSelect castingMaterial_metal waxError") {
                $(element).removeClass('waxError');
            }

            else if ($(element).attr('class') == "castingMaterials_OtherMaterial waxError") {
                $(element).removeClass('waxError');
            }

          


        },

        errorPlacement: function(error, element) {

            if ($(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.FirstName" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.LastName" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.BusinessPhoneNumber" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.MobilePhoneNumber" || $(element).attr("name") == "CadCamProfileViewModel.SelectedContactViewModel.EmailAddress") {
                $(element).addClass('has-error');
                $(element).siblings('.inputError').addClass('errorShow');
            }

            else if ($(element).attr("class") == "fullWidth xsWidthSelect castingMaterial_material" || $(element).attr('class') == "fullWidth xsWidthSelect castingMaterial_material waxError") {
                $(element).addClass('waxError');
            }

            else if ($(element).attr("class") == "xsWidthSelect castingMaterial_metal" || $(element).attr('class') == "xsWidthSelect castingMaterial_metal waxError") {
                $(element).addClass('waxError');
            }

            else if ($(element).attr('class') == "castingMaterials_OtherMaterial" || $(element).attr('class') == "castingMaterials_OtherMaterial waxError") {
                $(element).addClass('waxError');
            }

            else if ($(element).attr("name") == "Quantity" || $(element).attr("name") == "StullerItemNumber") {
                $(element).siblings('.inputError').addClass('errorShow');
            }
            
            else if ($(element).attr("name") == "BaseMetal" || $(element).attr("name") == "BaseMetalVerbose") {
                $(element).siblings('.metalError').addClass('errorShow');
            }

            else if ($(element).attr("class") == "trim" || $(element).attr("class") == "trimVerbose") {
                $(element).siblings('.metalError').addClass('errorShow');
            }

            else {
                $(error).insertBefore(element);
            }
        },

        rules: {
            "CadCamProfileViewModel.SelectedContactViewModel.FirstName": {
                required: true,
            },
            "CadCamProfileViewModel.SelectedContactViewModel.LastName": {
                required: true,
            },
            "CadCamProfileViewModel.SelectedContactViewModel.BusinessPhoneNumber": {
                required: true
            },
            //"CadCamProfileViewModel.SelectedContactViewModel.MobilePhoneNumber": {
            //    required: true
            //},
            "CadCamProfileViewModel.SelectedContactViewModel.EmailAddress": {
                required: true,
                email: true
            },
            "sketchFile": {
                required: true
            },
            "CadModel": {
                filesize: 250000000,
            },
            "RingSize": {
                required: function(element) {
                    return $('#ProductType').val() == "Ring";
                }
            },
            "IsMatchingWeddingBand": {
                required: true
            },
            "WillSendMatchingEngagement": {
                required: function(element) {
                    return $('#IsMatchingWeddingBandYes').is(':checked');
                }
            },
            "AcceptMatchingEngagmentAgreement": {
                required: function(e) {
                    return $('#WillSendMatchingEngagement').is(':checked');
                }
            },
            "StullerItemNumber": {
                required: true
            },
            "Quantity": {
                required: true,
                number: true
            },
            "CastingGroups[0].Base.Metal": {
                required: true
            },
            "CastingGroups[0].Base.MetalVerbose": {
                required: true
            },
            "FinishType": {
                required: true
            },
            "SpecialFinish": {
                required: function() {
                    return $('#FinishTypeSpecial').is(':checked');
                }
            },
            "AssemblyType": {
                required: true
            },
            "SettingType": {
                required: true
            },
            "StoneType": {
                required: function() {
                    return $('#SettingTypeStuller').is(':checked');
                }
            },
            "StullerStoneComments": {
                required: function() {
                    return ($('#StoneTypeStuller').is(':checked') || $('#StoneTypeMixed').is(':checked'));
                }
            },
            "CustomerStoneComments": {
                required: function() {
                    return ($('#StoneTypeCustomer').is(':checked') || $('#StoneTypeMixed').is(':checked'));
                }
            },
            "MixedStoneComments": {
                required: function() {
                    return $('#StoneTypeMixed').is(':checked');
                }
            },
            "WaxMemo": {
                required: true
            },

            "TrademarkType": {
                required: true
            },
            "TumbleFinishCost": {
                required: true
            },
            "IncludeEngraving": {
                required: true
            },
            "TrademarkLogo": {
                required: function() {
                    if ($('#TrademarkTypeStullerAndCustomer').is(":checked") || $('#TrademarkTypeCustomer').is(":checked")) {
                        return $("#LogoOnFileYes").is(":checked") ? false : true;
                    } else {
                        return false;
                    }
                }
            },
            "EngravingText": {
                required: function(element) {
                    return $('#IncludeEngravingYes').is(':checked');
                }
            },
            "FontFaceOptions": {
                required: function(element) {
                    return $('#IncludeEngravingYes').is(":checked");
                }
            },
            "FontSizeOptions": {
                required: function(element) {
                    return $('#IncludeEngravingYes').is(":checked");
                }
            },
            "FillOptions": {
                required: function(element) {
                    return $('#IncludeEngravingYes').is(":checked");
                }
            },
            "MoreThanARingCheck": {
                required: true
            },
            "IncludeStullerPackaging": {
                required: true
            }
        },
        focusInvalid: false,
        invalidHandler: function (form, validator) {
            if (!validator.numberOfInvalids())
                return;

            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top-100
            }, 750);

            $("#bypassQuoteLegalNotice").modal('hide');

        }
    });

    jQuery.validator.addClassRules('trim', {
        required: true
    });

    jQuery.validator.addClassRules('trimVerbose', {
        required: true
    });

    if ($(".castingMaterial_description").length) {
        jQuery.validator.addClassRules('castingMaterial_description',
            {
                required: true
            });
    }

    if ($(".castingMaterial_material").length) {
        jQuery.validator.addClassRules('castingMaterial_material',
            {
                required: true
            });
    }

    if ($(".castingMaterial_metal").length) {
        jQuery.validator.addClassRules('castingMaterial_metal',
            {
                required: true
            });
    }

    // Modal Lightbox Gallery Plugin
    $(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $('#partTable').on('click', '.panel-delete', camPartRowDelete);

    function camPartRowDelete(e) {
        e.preventDefault();
        var parentRowClass = $(this).parents('tr').attr('class');
        $(this).parents('tbody').find('tr.' + parentRowClass).remove();
    };

    $('div.formWell > input').focus(function() {
        $(this).siblings('i').css('color', '#75b0da');
        $(this).parent().css('borderColor', '#75b0da');
    }).blur(function() {
        $(this).siblings('i').css('color', '#E4E4E4');
        $(this).parent().css('borderColor', '#E4E4E4');
    });

    $('#Quantity, #Profile_Phone').keypress(function(evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57))
            return false;

        return true;
    });

    $('.CadCamDetailContentTabs li').on("click", CadCamDetailContentChange);

    function CadCamDetailContentChange() {
        // Check to see if current tab clicked is the on-state
        if ($(this).hasClass("CadCamDetailContentTabOnState")) {
            return;
        }

        // Remove on-state of previous tab and add it to the one selected
        $('.CadCamDetailContentTabs li').removeClass('CadCamDetailContentTabOnState');
        $(this).addClass('CadCamDetailContentTabOnState');

        // Get index of tab clicked
        var CadCamDetailContentTabIndex = $(this).index();

        // Fade out content area, when that is finished, fade in new content area
        $.when($('.CadCamDetailContentArea > div').fadeOut()).done(function() {
            $('.CadCamDetailContentArea > div').eq(CadCamDetailContentTabIndex).fadeIn();
        });
    }

    $('#pageSize').change(function () {
        $('form').submit();
    });

    if ($('.CadCamValidationSummary > div').html() != "") {
        $('.CadCamValidationSummary').fadeIn();
    }

    if ($('.CadCamSuccessMessage > div').html() != "") {
        $('.CadCamSuccessMessage').fadeIn();
    }
});
